import { Injector } from '@angular/core';

import { StyleOptions } from '@frontend/loaders';
import { ClientConfigProductName } from '@frontend/vanilla/core';

import { LAZY_STYLES_CONFIG } from '../lazy-features/lazy-styles.config';

export const TopEventsLoader = {
    id: 'top-events',
    loaderFn: () => import(/* webpackChunkName: "ms-top-events" */ './top-events.feature'),
    additionalStylesFn: (injector: Injector): StyleOptions[] | undefined =>
        injector.get(LAZY_STYLES_CONFIG).isEpcotEnabled ? [{ id: 'epcot-top-events', type: 'theme' }] : undefined,
    product: ClientConfigProductName.SPORTS,
};
